<template>
  <div
    class="lv-img-preview-btn"
    @mouseenter="mouseShowDeleteBtn = true"
    @mouseleave="mouseShowDeleteBtn = false"
  >
    <LoadingAnimate v-if="isLoading" primary />
    <div
      class="lv-img-preview-btn__img"
      :class="{
        small,
        medium,
        large,
        'disable-hover': _hideHover,
        'no-scope': !hasScope,
      }"
      :style="hasScope && url ? { backgroundImage: `url('${url}')` } : null"
      @click="hasScope ? previewPopUpOpen() : null"
    >
      <i
        v-if="hasScope && _showDeleteBtn"
        class="icon-cancel lv-img-preview-btn__icon"
        @click.stop="$_onClickDelete"
      />
      <LvText v-if="!hasScope" h4 bold class="lv-img-preview-btn__name">
        {{ $t('無權限') }}
      </LvText>
    </div>
    <div v-if="showZoomIcon" class="lv-img-preview-btn__zoom-in" @click.stop="previewPopUpOpen()">
      <div class="lv-img-preview-btn__zoom-in-icon-wrap">
        <i
          v-if="showDownloadBtn && hasScope"
          class="icon icon-cloud-download"
          @click.stop="$_onDownload(url)"
        />
        <i
          v-if="_showDeleteBtn && hasScope"
          class="icon icon-cancel"
          @click.stop="$_onClickDelete()"
        />
        <i v-if="showMoreBtn & hasScope" class="icon icon-more" @click.stop="$_onClickMore()" />
      </div>
      <i class="lv-img-preview-btn__zoom-in-icon icon-zoom-in" />
      <div class="lv-img-preview-btn__zoom-in-bg" />
    </div>
    <LvPopupPreview
      :ref="'popup' + num"
      :num="num"
      :url="url"
      :name="name"
      :popUpActive="isActive.previewPopup"
      :showMoreBtn="showMoreBtn && hasScope"
      :download="showDownloadBtn && hasScope"
      :fileType="fileType"
      :versionNumber="versionNumber"
      @click="$_onClosePopup('previewPopup')"
      @go-to="$_onClickMore()"
    />
    <LvPopupDeleteFile
      ref="LvPopupDeleteFile"
      :id="id"
      :module="module"
      :isSystem="isSystem"
      @remove="$emit('remove')"
    />
  </div>
</template>
<script>
import S_file from '@/service/api/v1/file';

export default {
  props: {
    small: {
      type: Boolean,
      default: false,
    },
    medium: {
      type: Boolean,
      default: false,
    },
    upload: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
    },
    url: {
      type: String,
    },
    hasScope: {
      type: Boolean,
      default: false,
    },
    isSystem: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    showDeleteBtn: {
      type: Boolean,
      default: false,
    },
    num: {
      type: Number,
      default: 0,
    },
    module: {
      type: String,
    },
    showZoomIcon: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    showDownloadBtn: {
      type: Boolean,
      default: false,
    },
    showMoreBtn: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
    },
    fileType: {
      type: String,
    },
    versionNumber: {
      type: [String, Number],
    },
  },
  data() {
    return {
      isActive: {
        previewPopup: false,
      },
      mouseShowDeleteBtn: false,
    };
  },
  computed: {
    _showDeleteBtn() {
      if (!this.showDeleteBtn) return false;
      return (this.showDeleteBtn || (this.upload && !this.isLoading)) && this.mouseShowDeleteBtn;
    },
    _hideHover() {
      if (this.hasScope) return false;
      else if (this.upload) return false;
      else return true;
    },
  },
  methods: {
    previewPopUpOpen() {
      if (this.isLoading || !this.hasScope) return;
      this.$_onOpenPopup('previewPopup');
      this.$emit('no-scroll');
    },
    $_onOpenPopup(type) {
      this.isActive[type] = true;
    },
    $_onClosePopup(type) {
      if (!this.isActive[type]) return;
      this.isActive[type] = false;
    },
    async $_onClickDelete() {
      await this.$refs.LvPopupDeleteFile.$_onOpenPopup('popup');
    },
    $_onClickMore() {
      this.$emit('go-to', this.id);
    },
    async $_onDownload(url) {
      if (!url || !this.name || !this.fileType) {
        this.$store.dispatch('downloadPopup/open');
        this.$store.dispatch('downloadPopup/showError', '下載失敗，請稍後再試');
        return;
      }
      await S_file.download(url, this.name, this.fileType, this.versionNumber);
    },
  },
};
</script>
